export const SERVICE_ID_PREFIX = 'reservation_service'
export const DEFAULT_SLOT_LENGTH = 30
